import {Button, HStack, Stack, Tooltip} from '@chakra-ui/react'
import {faRocketLaunch, faTrash} from '@fortawesome/pro-regular-svg-icons'
import {faPlay} from '@fortawesome/pro-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import useTranslation from 'next-translate/useTranslation'
import {useRouter} from 'next/router'
import {SUPPORTED_LANGUAGES} from '../../constants/languages'
import {useSkill} from '../../hooks/useSkill'
import {track} from '../../utils/eventTracking/track'

interface Props {
  getRandomExample: () => void
  onDelete: () => void
}

const SkillOptionBar = ({getRandomExample, onDelete}: Props) => {
  const {t} = useTranslation('skill')
  const {isLoading, skill} = useSkill()
  const selectedLanguage = useRouter().locale ?? 'en'

  return (
    <Stack
      direction={['column', null, null, 'row']}
      spacing={[5, null, 7]}
      w='full'
      align='center'
      justify='space-between'>
      <HStack w='full' justify='space-between' py={1}>
        <Tooltip label={t('gen_delete')} placement='top'>
          <Button
            variant='textIcon'
            onClick={() => {
              onDelete()
            }}
            isDisabled={isLoading}
            aria-label='Delete content'>
            <FontAwesomeIcon icon={faTrash} />
          </Button>
        </Tooltip>
        <Tooltip label={t('common:tooltip_examples')} placement='top'>
          <Button
            variant='textLarge'
            leftIcon={<FontAwesomeIcon icon={faRocketLaunch} />}
            onClick={() => {
              getRandomExample()
              track(`feature-click-${skill.skillName}-examples-button`)
            }}
            isDisabled={isLoading || selectedLanguage == SUPPORTED_LANGUAGES.de}>
            {t('block_skill_input_button_example')}
          </Button>
        </Tooltip>
      </HStack>
      <Button
        w={['full', null, 'auto']}
        isDisabled={isLoading}
        variant='primary'
        type='submit'
        isLoading={isLoading}
        rightIcon={<FontAwesomeIcon icon={faPlay} />}>
        {t('block_skill_input_button_main')}
      </Button>
    </Stack>
  )
}
export default SkillOptionBar
